module.exports = __webpack_public_path__ + "static/media/taskList.5eba44f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/taskList.png
// module id = 275
// module chunks = 0